<template>
  <SettlementStepCard
    title="Order Acceptance"
    :status="status"
    :status-color="statusColor"
    :isMobile="isMobile"
    v-bind="$attrs"
  >
    <p v-if="accepted" :class="{ 'text-body': isMobile }">
      <b>{{ dealerName }}</b> has accepted your order! The estimated delivery
      date for your car is now
      <b v-if="approximateDelivery">{{
        approximateDelivery | ParseDateFilter
      }}</b
      >.
    </p>
    <p :class="['text-grey-6', { 'text-body': isMobile }]" v-else>
      Waiting for a dealer to accept your order.
    </p>
  </SettlementStepCard>
</template>

<script>
export default {
  name: 'SettlementAcceptanceCard',
  props: {
    status: String,
    statusColor: String,
    accepted: Boolean,
    dealerName: String,
    approximateDelivery: String,
    isMobile: Boolean
  },
  components: {
    SettlementStepCard: () => import('../settlement-step-card')
  }
};
</script>
